import { render, staticRenderFns } from "./SystemMemoryChart.vue?vue&type=template&id=3a7b1b36&"
import script from "./SystemMemoryChart.vue?vue&type=script&lang=ts&"
export * from "./SystemMemoryChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
